/**
 * EMI Card Service
 * Migrated from 3in1cms legacy/emiCardApi.ts
 */

import { getUtmParamsFromCookie } from "@repo/shared-utils/common-utils";
import { getOrDefaultValue } from "@repo/shared-utils/insert-params";
import { request } from "../core/request";
import { CONNECTION_MANAGER_ENV, OPERATION_IDS, REST_CONNECTION_FROM } from "./constants";
import type { IOtpRetryData, IOtpRetryRequest, IOtpRetryResponse } from "../types/emiCartTypes";
import type { IUTMParams } from "../types/utmTypes";

// EMI Card constants (from legacy constant/emiCard)
const CHANNEL_INFO = {
  lowerEnv: {
    channelId: "WEB_UAT",
    channelKey: "web_uat_key",
  },
  higherEnv: {
    channelId: "WEB_PROD",
    channelKey: "web_prod_key",
  },
};

const DEFAULT_IP_ADDRESS = "0.0.0.0";
const PARTNER_APP_ID = "BFL_WEB";
const PRIMARY_ADD_ON_IND = "P";
const SUBSCRIPTION_KEY = "emi_card_subscription";

/**
 * OTP retry API for EMI card
 * @param data - Optional OTP retry data
 * @param mobileNumber - Customer mobile number
 * @returns OTP retry response
 */
export const otpRetryApi = async (
  data: IOtpRetryData | undefined,
  mobileNumber: string
): Promise<IOtpRetryResponse> => {
  try {
    const utm = getUtmParamsFromCookie() as IUTMParams;
    const { channelId, channelKey } =
      CONNECTION_MANAGER_ENV === "UAT" ? CHANNEL_INFO.lowerEnv : CHANNEL_INFO.higherEnv;

    const requestData: IOtpRetryRequest = {
      ...(data ?? {}),
      mobileNumber,
      partnerApplicationId: PARTNER_APP_ID,
      utmSource: getOrDefaultValue(utm?.utmSource),
      utmCampaign: getOrDefaultValue(utm?.utmCampaign),
      utmMedium: getOrDefaultValue(utm?.utmMedium),
      sourceChannelIp: DEFAULT_IP_ADDRESS,
      customerDeviceIp: DEFAULT_IP_ADDRESS,
      primaryAddonIndicator: PRIMARY_ADD_ON_IND,
      channelId,
      channelKey,
      subscriptionKey: SUBSCRIPTION_KEY,
      requestDatetime: new Date().toISOString(),
    };

    const response = (await request<IOtpRetryResponse, IOtpRetryRequest>({
      operationId: OPERATION_IDS.otpRetry,
      requestData: requestData,
      connectionFrom: REST_CONNECTION_FROM,
    })) as IOtpRetryResponse;

    return response;
  } catch (error) {
    console.error("Error in otpRetryApi", error);
    return {};
  }
};
